module.exports = __webpack_public_path__ + "img/morning_study1.2af0fa69.png";